import { render, staticRenderFns } from "./permissionDenied.vue?vue&type=template&id=202b3c7c&scoped=true&"
import script from "./permissionDenied.vue?vue&type=script&lang=js&"
export * from "./permissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./permissionDenied.vue?vue&type=style&index=0&id=202b3c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b3c7c",
  null
  
)

export default component.exports